import React, {useEffect} from 'react';
import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import {useDispatch, useSelector} from "react-redux";
import {getOperadores} from "../../../actions/stationActions";

const tableIcons = {
    Add: AddBox,
    Check: Check,
    Clear: Clear,
    Delete: DeleteOutline,
    DetailPanel: ChevronRight,
    Edit: Edit,
    Export: SaveAlt,
    Filter: FilterList,
    FirstPage: FirstPage,
    LastPage: LastPage,
    NextPage: ChevronRight,
    PreviousPage: ChevronLeft,
    ResetSearch: Clear,
    Search: Search,
    SortArrow: ArrowUpward,
    ThirdStateCheck: Remove,
    ViewColumn: ViewColumn
};

const OperadoresTabela = (props) => {
    const operadores = useSelector(st => st.stations.operadores);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getOperadores());
    }, []);

    const getColumns = () => {
        return [
            { title: 'ID', field: 'id' },
            { title: 'Nome', field: 'nome' },
            { title: 'Abreviatura', field: 'abreviatura' },
            { title: 'Alerta Após X Horas', field: 'alertaAposXHoras' },
        ];
    }

    return (
        <React.Fragment>
            <MaterialTable
                icons={tableIcons}
                title="Operadores"
                columns={getColumns()}
                data={operadores || []}
                actions={[
                    {
                        icon: AddBox,
                        tooltip: 'Novo Operador',
                        isFreeAction: true,
                        onClick: (event) => {
                            props.openDialog(true, null);
                        }
                    }
                ]}
                options={{
                    filtering: true,
                    pageSize: 15,
                    pageSizeOptions: [10, 15, 25],
                }}
            />
        </React.Fragment>
    );
}

export default OperadoresTabela;
